import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2Icon, XIcon } from 'lucide-react';
import { SPANISH_CITIES, SPANISH_NAMES } from '../lib/data';
function randomOf<T>(arr: T[]): T {
  return arr[Math.floor(Math.random() * arr.length)];
}
export function SalesPopup() {
  const [visible, setVisible] = useState(false);
  const [data, setData] = useState({
    name: 'Laura G.',
    city: 'Madrid',
    mins: 3
  });
  useEffect(() => {
    let hideTimer: ReturnType<typeof setTimeout>;
    const show = () => {
      setData({
        name: randomOf(SPANISH_NAMES),
        city: randomOf(SPANISH_CITIES),
        mins: Math.floor(Math.random() * 20) + 1
      });
      setVisible(true);
      hideTimer = setTimeout(() => setVisible(false), 5000);
    };
    const firstTimer = setTimeout(show, 4000);
    const interval = setInterval(show, 16000);
    return () => {
      clearTimeout(firstTimer);
      clearTimeout(hideTimer);
      clearInterval(interval);
    };
  }, []);
  return <AnimatePresence data-id="element-194" data-mp="1zt5xpgvmsyah">
      {visible && <motion.div initial={{
      opacity: 0,
      x: -40,
      y: 10
    }} animate={{
      opacity: 1,
      x: 0,
      y: 0
    }} exit={{
      opacity: 0,
      x: -40
    }} transition={{
      type: 'spring',
      stiffness: 260,
      damping: 24
    }} className="fixed bottom-4 left-3 right-3 z-40 mx-auto max-w-[340px]" role="status" data-id="element-195" data-mp="24qfx9pcqiqc1">
          <div className="flex items-start gap-3 rounded-2xl border border-hockey-pink/30 bg-hockey-card/95 p-3 pr-8 shadow-xl backdrop-blur" data-id="element-196" data-mp="2ihb1upg7al9t">
            <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-hockey-pink/20" data-id="element-197" data-mp="2sga9q5t56cvr">
              <CheckCircle2Icon className="h-6 w-6 text-hockey-pink" data-id="element-198" data-mp="2xf3ftd63n1lw" />
            </div>
            <div className="min-w-0" data-id="element-199" data-mp="y292oxnfujkl">
              <p className="text-[13px] font-bold leading-tight text-white" data-id="element-200" data-mp="y3anvuy64mg1">
                {data.name} de {data.city}
              </p>
              <p className="text-[12px] leading-tight text-white/70" data-id="element-201" data-mp="133gagwpkzir9">
                acaba de comprar Hockey Pro System 🏑
              </p>
              <p className="mt-0.5 text-[11px] text-white/40" data-id="element-202" data-mp="q233yerzay7h">hace {data.mins} min · Compra verificada</p>
            </div>
            <button type="button" onClick={() => setVisible(false)} aria-label="Cerrar aviso" className="absolute right-2 top-2 text-white/40 hover:text-white" data-id="element-203" data-mp="14zlo13tpon8l">
              <XIcon className="h-4 w-4" data-id="element-204" data-mp="1dxffa0cmcqow" />
            </button>
          </div>
        </motion.div>}
    </AnimatePresence>;
}